/* ============================================================
   Mythos US Flagship - app.js
   Direction B: The Armory
   Interactions: nav shrink, hero reveal, mobile flip, gallery swap,
   FAQ accordion (+ auto FAQPage JSON-LD), sticky buy bar, skip-cart stubs.
   No external dependencies. No AI attribution anywhere.
   ============================================================ */
(function(){
  "use strict";
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- nav shrink on scroll ---- */
  var nav = document.querySelector(".nav");
  function onScrollNav(){
    if(!nav) return;
    if(window.scrollY > 30) nav.classList.add("shrink");
    else nav.classList.remove("shrink");
  }
  window.addEventListener("scroll", onScrollNav, {passive:true});
  onScrollNav();

  /* ---- hero theatre reveal ---- */
  var theatre = document.querySelector(".theatre");
  if(theatre){
    if(reduceMotion){ theatre.classList.add("in"); }
    else {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ theatre.classList.add("in"); io.disconnect(); } });
      }, {threshold:.2});
      io.observe(theatre);
      // also reveal shortly after load in case it's already in view
      window.addEventListener("load", function(){ setTimeout(function(){ theatre.classList.add("in"); }, 120); });
    }
  }

  /* ---- mobile flip card ---- */
  var flipWrap = document.querySelector(".flipwrap");
  var flipBtns = document.querySelectorAll(".flip-toggle button");
  function setFlip(side){
    if(!flipWrap) return;
    flipWrap.classList.toggle("flipped", side === "back");
    flipBtns.forEach(function(b){ b.classList.toggle("on", b.getAttribute("data-side") === side); });
  }
  flipBtns.forEach(function(b){ b.addEventListener("click", function(){ setFlip(b.getAttribute("data-side")); }); });

  /* ---- anatomy gallery swap ---- */
  var galStage = document.getElementById("galStageImg");
  var gfeats = document.querySelectorAll(".gfeat");
  gfeats.forEach(function(f){
    f.addEventListener("click", function(){
      var src = f.getAttribute("data-img");
      var alt = f.getAttribute("data-alt") || "";
      if(galStage && src){
        galStage.classList.remove("show");
        var pre = new Image();
        pre.onload = function(){ galStage.src = src; galStage.alt = alt; galStage.classList.add("show"); };
        pre.src = src;
      }
      gfeats.forEach(function(x){ x.classList.remove("active"); });
      f.classList.add("active");
      if(window.matchMedia("(max-width: 880px)").matches && galStage){
        var r = galStage.getBoundingClientRect();
        if(r.top < 60 || r.bottom > window.innerHeight){
          galStage.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    });
  });
  if(galStage){ requestAnimationFrame(function(){ galStage.classList.add("show"); }); }

  /* ---- FAQ accordion + JSON-LD ---- */
  var faqItems = document.querySelectorAll(".faq-item");
  faqItems.forEach(function(item){
    var q = item.querySelector(".faq-q");
    var a = item.querySelector(".faq-a");
    if(!q || !a) return;
    q.addEventListener("click", function(){
      var open = item.classList.contains("open");
      if(open){ item.classList.remove("open"); a.style.maxHeight = null; }
      else { item.classList.add("open"); a.style.maxHeight = a.scrollHeight + "px"; }
    });
  });
  window.addEventListener("resize", function(){
    document.querySelectorAll(".faq-item.open .faq-a").forEach(function(a){ a.style.maxHeight = a.scrollHeight + "px"; });
  });
  // Build FAQPage JSON-LD from the same DOM blocks so copy and structured data never drift.
  (function buildFaqLd(){
    if(!faqItems.length) return;
    var entities = [];
    faqItems.forEach(function(item){
      var q = item.querySelector(".faq-q");
      var a = item.querySelector(".faq-a .inner");
      if(!q || !a) return;
      entities.push({
        "@type":"Question",
        "name": q.textContent.trim(),
        "acceptedAnswer":{ "@type":"Answer", "text": a.textContent.replace(/\s+/g," ").trim() }
      });
    });
    var ld = { "@context":"https://schema.org", "@type":"FAQPage", "mainEntity": entities };
    var s = document.createElement("script");
    s.type = "application/ld+json";
    s.textContent = JSON.stringify(ld);
    document.head.appendChild(s);
  })();

  /* ---- product gallery: thumbnail -> main image ---- */
  var galleryMain = document.querySelector(".gallery-main .gallery-photo");
  var galleryCap  = document.querySelector(".gallery-cap");
  var thumbs = document.querySelectorAll(".gthumb");
  thumbs.forEach(function(t){
    t.addEventListener("click", function(){
      thumbs.forEach(function(x){ x.classList.remove("active"); });
      t.classList.add("active");
      var src = t.getAttribute("data-img");
      if(galleryMain && src) galleryMain.src = src;
      /* only overwrite the caption when the media carries its own alt text,
         otherwise keep the section's default caption */
      var cap = t.getAttribute("data-cap");
      if(galleryCap && cap) galleryCap.textContent = cap;
    });
  });

  /* ---- quantity steppers (+ live line total on the add-to-cart button) ---- */
  document.querySelectorAll("[data-qty-val]").forEach(function(valEl){
    var group  = valEl.closest(".qty");
    if(!group) return;
    var unit   = parseInt(group.getAttribute("data-unit"), 10);   /* price in cents */
    var form   = group.closest(".product-buy");
    var totalEl = form ? form.querySelector("[data-line-total]") : null;
    var hidden  = group.querySelector('input[name="quantity"]');
    function setTotal(q){
      if(!totalEl || !unit) return;
      totalEl.textContent = "$" + (unit * q / 100).toLocaleString("en-US", {minimumFractionDigits:2, maximumFractionDigits:2});
    }
    group.querySelectorAll("[data-qty]").forEach(function(b){
      b.addEventListener("click", function(){
        var q = parseInt(valEl.textContent, 10) || 1;
        q = Math.max(1, Math.min(10, q + (b.getAttribute("data-qty") === "inc" ? 1 : -1)));
        valEl.textContent = q;
        if(hidden) hidden.value = q;
        setTotal(q);
      });
    });
  });

  /* ---- sticky buy bar ---- */
  var sticky = document.querySelector(".sticky-buy");
  var hero = document.querySelector(".hero");
  var capture = document.querySelector(".capture");
  function onScrollSticky(){
    if(!sticky || !hero) return;
    var heroBottom = hero.offsetTop + hero.offsetHeight;
    var pastHero = window.scrollY > heroBottom - 120;
    // hide again once the email-capture/footer region is reached (CTA already present there)
    var nearEnd = capture && (window.scrollY + window.innerHeight > capture.offsetTop + 80);
    sticky.classList.toggle("show", pastHero && !nearEnd);
  }
  window.addEventListener("scroll", onScrollSticky, {passive:true});
  onScrollSticky();

  /* ---- skip-cart buy stub ----
     Production wires this to POST /cart/add.js then redirect to /checkout,
     with the native <form action="/cart/add"> as the no-JS fallback.
     In the static comp it is a clearly-labeled stub. */
  /* ---- buy buttons: skip-cart straight to checkout ----
     POST the featured variant to /cart/add.js, then go to /checkout.
     Falls back to the product page if config or the request fails. */
  function buyNow(e){
    var cfg = window.MYTHOS || {};
    var btn = e.currentTarget;
    var explicit = btn && btn.getAttribute && btn.getAttribute("data-variant-id");
    /* On a product page a button with no explicit variant must NEVER fall back to the
       site-wide featured variant: that would add a different paddle than the one on screen.
       Return before any preventDefault so the link behaves natively. */
    if(!explicit && document.body.classList.contains("tmpl-product")){ return; }
    var vid = explicit || cfg.variantId;
    if(!vid){
      if(cfg.productUrl){ e.preventDefault(); window.location.href = cfg.productUrl; }
      return;                      /* no config at all: let the link act naturally */
    }
    e.preventDefault();
    btn.style.opacity = ".6";
    fetch(cfg.cartAddUrl || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
    }).then(function(r){
      if(!r.ok) throw new Error("cart add failed");
      window.location.href = cfg.checkoutUrl || "/checkout";
    }).catch(function(){
      btn.style.opacity = "";
      window.location.href = cfg.productUrl || (cfg.cartUrl || "/cart");
    });
  }
  document.querySelectorAll("[data-buy]").forEach(function(b){ b.addEventListener("click", buyNow); });

  /* ---- newsletter stub ---- */
  var capForm = document.querySelector(".capture form");
  if(capForm){
    capForm.addEventListener("submit", function(e){
      e.preventDefault();
      var wrap = capForm.parentNode;
      var msg = wrap.querySelector(".cap-msg");
      if(!msg){
        msg = document.createElement("p");
        msg.className = "cap-msg";
        msg.style.cssText = "color:#46B46E;font-size:13.5px;margin-top:4px";
        wrap.appendChild(msg);
      }
      msg.textContent = "Comp stub: Klaviyo captures the email and issues the additional 10% code in the live theme.";
      capForm.reset();
    });
  }

  /* ---- year ---- */
  var y = document.querySelector("[data-year]");
  if(y) y.textContent = new Date().getFullYear();
})();

/* ---- community wall: paged carousel ----
   Prev/next buttons page through the strip roughly a viewport at a
   time, landing exactly on tile boundaries. The glide is self-animated
   (rAF ease-out) so it works even where native smooth scrolling is
   unavailable. Wraps around at the ends. Swipe and trackpad scrolling
   still work natively on the track. */
(function(){
  var track = document.querySelector(".cm-track");
  if(!track) return;
  var prev = document.querySelector(".cm-btn.prev");
  var next = document.querySelector(".cm-btn.next");
  var gliding = false;
  function glide(to){
    var from = track.scrollLeft, d = to - from, t0 = null, DUR = 380;
    if(Math.abs(d) < 2) return;
    gliding = true;
    var fallback = setTimeout(function(){
      if(gliding){ track.scrollLeft = to; gliding = false; }
    }, DUR + 250);
    function step(ts){
      if(t0 === null) t0 = ts;
      var k = Math.min((ts - t0) / DUR, 1);
      var e = 1 - Math.pow(1 - k, 3);
      track.scrollLeft = from + d * e;
      if(k < 1){ requestAnimationFrame(step); }
      else { gliding = false; clearTimeout(fallback); }
    }
    requestAnimationFrame(step);
  }
  function stride(){
    var imgs = track.querySelectorAll("img");
    if(imgs.length < 2) return 200;
    return imgs[1].offsetLeft - imgs[0].offsetLeft;
  }
  function page(dir){
    if(gliding) return;
    var st = stride();
    var w = track.clientWidth;
    var max = track.scrollWidth - w;
    var cur = track.scrollLeft;
    var jump = Math.max(st, Math.floor((w * 0.9) / st) * st);
    var target;
    if(dir > 0){ target = cur >= max - 8 ? 0 : Math.min(cur + jump, max); }
    else { target = cur <= 8 ? max : Math.max(cur - jump, 0); }
    if(target > 0 && target < max) target = Math.round(target / st) * st;
    glide(target);
  }
  if(prev) prev.addEventListener("click", function(){ page(-1); });
  if(next) next.addEventListener("click", function(){ page(1); });
})();

/* ---- stack third-party bottom bars (Klaviyo teaser) above the sticky buy bar ----
   Our buy bar owns the very bottom edge (full-width, flush). Any foreign
   full-width fixed bar pinned near the bottom (like the Klaviyo teaser)
   is lifted to sit directly on top of it, and restored when the bar hides. */
(function(){
  var bar = document.querySelector(".sticky-buy");
  if(!bar) return;
  function foreignBars(){
    var list = [];
    document.querySelectorAll("body *").forEach(function(el){
      if(el === bar || bar.contains(el) || el.contains(bar)) return;
      var cls = (el.className || "").toString();
      if(cls.indexOf("grain") > -1) return;
      var cs = getComputedStyle(el);
      if(cs.position !== "fixed" || cs.visibility === "hidden" || cs.display === "none") return;
      var r = el.getBoundingClientRect();
      if(r.height < 24 || r.height > 220) return;
      if(r.width < window.innerWidth * 0.5) return;
      if(window.innerHeight - r.bottom > 160) return;
      list.push(el);
    });
    return list;
  }
  var t = null;
  function adjust(){
    bar.style.bottom = "";
    var lift = bar.classList.contains("show") ? bar.offsetHeight : 0;
    foreignBars().forEach(function(el){
      if(lift){ el.style.setProperty("bottom", lift + "px", "important"); }
      else { el.style.removeProperty("bottom"); }
    });
  }
  function schedule(){
    if(t) return;
    t = setTimeout(function(){ t = null; adjust(); }, 300);
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener("resize", schedule);
  setInterval(adjust, 2000);
  adjust();
})();

/* ---- mobile nav menu ---- */
(function(){
  var nav = document.querySelector(".nav");
  var burger = document.querySelector(".nav-burger");
  if(!nav || !burger) return;
  function set(open){
    nav.classList.toggle("menu-open", open);
    burger.setAttribute("aria-expanded", open ? "true" : "false");
  }
  burger.addEventListener("click", function(e){
    e.stopPropagation();
    set(!nav.classList.contains("menu-open"));
  });
  document.addEventListener("click", function(e){
    if(nav.classList.contains("menu-open") && !nav.contains(e.target)) set(false);
  });
  document.querySelectorAll(".nav-menu a").forEach(function(a){
    a.addEventListener("click", function(){ set(false); });
  });
  document.addEventListener("keydown", function(e){ if(e.key === "Escape") set(false); });
})();
